<template lang="html">
  <img :style="style" class="mpv-icon-image" :src="src" alt="">
</template>

<script>
export default {
  props: {
    icon: String,
    scale: Number | null
  },

  computed: {
    src () { return `${this.$CDN_STATIC}/static/icons/svg/mpv-${this.icon}.svg` },

    style () {
      return {
        width: `calc(2rem * ${this.scale || 1})`,
        marginTop: `calc(-0.2rem * ${this.scale || 1})`
      }
    }
  }
}
</script>

<style lang="scss">
  .mpv-icon {
    &-image {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/MIcon.vue